import { produce } from 'immer';
import {
  CHECKIN_REQUEST,
  CHECKIN_SUCCESS,
  CHECKIN_FAILURE,
  WAITTIME_REQUEST,
  WAITTIME_SUCCESS,
  WAITTIME_FAILURE,
  CHECKIN_CANCEL_REQUEST,
  CHECKIN_UPDATE_REQUEST,
  CHECKIN_UPDATE_SUCCESS,
  CHECKIN_UPDATE_FAILURE,
  CHECKIN_DETAILS_REQUEST,
  CHECKIN_DETAILS_SUCCESS,
  CHECKIN_DETAILS_FAILURE,
  CHECKIN_CANCEL_SUCCESS,
  CHECKIN_CANCEL_FAILURE,
  CLEAR_CHECKIN_STATE, CHECKIN_STORE, SHOW_RESERVATION_STATUS, HIDE_RESERVATION_STATUS, FEEDBACK_SUBMITTED,
  RESERVATION_STORE,RESERVATION_FAILURE,RESERVATION_REQUEST,RESERVATION_SUCCESS,
  GET_RESERVATION_SESSION_REQUEST,
  GET_RESERVATION_SESSION_SUCCESS,
  GET_RESERVATION_SESSION_FAILURE,
  GET_RESERVATION_SESSION_NO_TABLE
} from "./checkInConstants";
import { CheckInActions } from './checkInActions';
import { CheckInState } from './checkInModels';


const initialCheckInState: CheckInState = {
  checkedIn: false,
  checkInRestaurantSlug: "",
  checkInBookingFormDetails: null,
  checkInConfirmationDetails: null,
  isFeedbackSubmitted: true,
  checkInFormState: null,
  checkInLoading: false,
  checkInMessage: "",
  waitTimes: [],
  waitTimeLoading: false,
  waitTimeMessage: "",
  checkInCancelled: false,
  checkInCancelLoading: false,
  checkInUpdated: false,
  checkInUpdateLoading: false,
  checkInBookedDetail: null,
  checkInReservationID: "",
  checkInDetailsLoading: false,
  floatingReservationVisible: true,
  CheckInSuccessResult :null,
  checkInFail:"",
  // Reservation:false,
  // ReservationRestaurantSlug:"",
  // ReservationBookingFormDetails:null


};


const initialReservationState: any = {
 

  Reservation: false,
  ReservationRestaurantSlug: "",
  ReservationBookingFormDetails: null,
  ReservationConfirmationDetails: null,
  isFeedbackSubmittedForReservation: true,
  ReservationFormState: null,
  ReservationLoading: false,
  ReservationMessage: "",
  // waitTimes: [],
  // waitTimeLoading: false,
  // waitTimeMessage: "",
  ReservationCancelled: false,
  ReservationCancelLoading: false,
  ReservationUpdated: false,
  ReservationUpdateLoading: false,
  ReservationBookedDetail: null,
  ReservationReservationID: "",
  ReservationDetailsLoading: false,
  floatingReservationVisible: true,
  ReservationSuccessResult :null,
  ReservationFail:"",
  //session data
  getSessionLoading:false,
  getSessionData:[],
  getSessionSuccess:[],
  getSessionfailure:false,
  Notable:false




};


export  function checkInReducer( state: CheckInState = initialCheckInState, action: CheckInActions) {

  return produce(state,(draft:any) => {
    switch (action.type) {
      case CLEAR_CHECKIN_STATE:
        draft.checkedIn = false;
        draft.checkInUpdated = false;
        draft.checkInCancelled = false;

        draft.checkInLoading = false;

        // draft.checkInBookedDetail = null;
        draft.checkInBookingFormDetails = null;
        draft.checkInConfirmationDetails = null;
        break;
      // CheckIn Reducers
      case CHECKIN_REQUEST:
        draft.checkedIn = false;
        draft.checkInRestaurantSlug = action.payload.restaurantSlug;
        draft.checkInLoading = true;
        draft.checkInConfirmationDetails = null;
        draft.checkInBookingFormDetails = action.payload;
        draft.checkInCancelled = false;
        draft.checkInUpdated = false;
        draft.checkInBookedDetail = null;
        draft.isFeedbackSubmitted = true;
        break;
      case CHECKIN_SUCCESS:
        draft.checkedIn = true;
        draft.CheckInSuccessResult = null;
        draft.checkInLoading = false;
        draft.checkInFormState = null;
        draft.checkInConfirmationDetails = action.payload;
        draft.isFeedbackSubmitted = action.payload.isFeedbackSubmitted;
        break;
      case CHECKIN_FAILURE:
        draft.checkedIn = false;
        draft.checkInLoading = false;
        draft.checkInConfirmationDetails = null;
        draft.checkInFail = action.payload.message
        break;
      case CHECKIN_STORE:
        draft.checkInFormState = action.payload;
        break;
      // WaitTime Reducers
      case WAITTIME_REQUEST:
        draft.waitTimeLoading = true;
        break;
      case WAITTIME_SUCCESS:
        draft.waitTimeLoading = false;
        draft.waitTimes = action.payload;
        break;
      case WAITTIME_FAILURE:
        draft.waitTimeLoading = false;
        draft.waitTimeMessage = action.payload.message;
        break;

      // Cancel CheckIN
      case CHECKIN_CANCEL_REQUEST:
        draft.checkInCancelLoading = true;
        draft.checkInCancelled = false;
        draft.checkedIn = false;
        break;
      case CHECKIN_CANCEL_SUCCESS:
        draft.checkInCancelLoading = false;
        draft.checkInCancelled = true;
        draft.checkInConfirmationDetails = null;
        draft.checkInBookingFormDetails = null;
        break;
      case CHECKIN_CANCEL_FAILURE:
        draft.checkInCancelLoading = false;
        draft.checkInCancelled = false;
        break;

      // Update CheckIn Reducers
      case CHECKIN_UPDATE_REQUEST:
        draft.checkInUpdateLoading = true;
        draft.checkInUpdated = false;
        break;
      case CHECKIN_UPDATE_SUCCESS:
        draft.checkInUpdateLoading = false;
        draft.checkInUpdated = true;
        break;
      case CHECKIN_UPDATE_FAILURE:
        draft.checkInUpdateLoading = false;
        draft.checkInUpdated = false;
        break;

      // CheckIn Details Reducers
      case CHECKIN_DETAILS_REQUEST:
        draft.checkInDetailsLoading = true;
        draft.checkInBookedDetail = null;
        draft.checkInReservationID = action.payload;
        break;
      case CHECKIN_DETAILS_SUCCESS:
        draft.checkInDetailsLoading = false;
        draft.checkInBookedDetail = action.payload;
        break;
      case CHECKIN_DETAILS_FAILURE:
        draft.checkInDetailsLoading = false;
        break;

      case SHOW_RESERVATION_STATUS:
        draft.floatingReservationVisible = true;
        break;
      case HIDE_RESERVATION_STATUS:
        draft.floatingReservationVisible = false;
        break;
      case FEEDBACK_SUBMITTED:
        draft.isFeedbackSubmitted = true;
        break;


       
      default:
        break;
    }
  });
}


export  function ReservationReducer( state: any = initialReservationState , action: CheckInActions) {

  return produce(state,(draft:any) => {
    switch (action.type) {
     //reservation
 case RESERVATION_REQUEST:
  draft.Reservation = false;
  draft.ReservationRestaurantSlug = action.payload.restaurantSlug;
  draft.ReservationLoading = true;
  draft.ReservationConfirmationDetails = null;
  draft.ReservationBookingFormDetails = action.payload;
  draft.ReservationCancelled = false;
  draft.ReservationUpdated = false;
  draft.ReservationBookedDetail = null;
  draft.isFeedbackSubmittedForReservation = true;

 
  
  break;
case RESERVATION_SUCCESS:
  draft.Reservation = true;
  draft.ReservationSuccessResult = null;
  draft.ReservationLoading = false;
  draft.ReservationFormState = null;
  draft.ReservationConfirmationDetails = action.payload;
  draft.isFeedbackSubmittedForReservation = action.payload.isFeedbackSubmitted;
  break;
case RESERVATION_FAILURE:
  draft.Reservation = false;
  draft.ReservationLoading = false;
  draft.ReservationConfirmationDetails = null;
  draft.ReservationFail = action.payload.message
  break;
case RESERVATION_STORE:
  draft.ReservationFormState = action.payload;
  break;
  //get session data

  case GET_RESERVATION_SESSION_REQUEST:
    draft.getSessionLoading=true;
    draft.getSessionData=[];
    draft.getSessionSuccess=[];
    draft.getSessionfailure=false;
    draft.Notable=false
    break;
    case GET_RESERVATION_SESSION_SUCCESS:
      draft.getSessionLoading=false;
      draft.getSessionData=[];
      draft.getSessionSuccess=action.payload;
      draft.getSessionfailure=false;
       draft.Notable=false
      break;
      case GET_RESERVATION_SESSION_FAILURE:
        draft.getSessionLoading=false;
        draft.getSessionData=[];
        draft.getSessionSuccess=[];
        draft.getSessionfailure=true;
         draft.Notable=false
        break;

         case GET_RESERVATION_SESSION_NO_TABLE:
        draft.getSessionLoading=false;
        draft.getSessionData=[];
        draft.getSessionSuccess=[];
        draft.getSessionfailure=true;
         draft.Notable=true;
        break;



       
      default:
        break;
    }
  });
}






 //reservation
//  case RESERVATION_REQUEST:
//   draft.Reservation = false;
//   draft.ReservationRestaurantSlug = action.payload.restaurantSlug;
//   draft.ReservationLoading = true;
//   draft.ReservationConfirmationDetails = null;
//   draft.ReservationBookingFormDetails = action.payload;
//   draft.ReservationCancelled = false;
//   draft.ReservationUpdated = false;
//   draft.ReservationBookedDetail = null;
//   draft.isFeedbackSubmittedForReservation = true;

//   console.log("fffh",action.payload);
  
//   break;
// case RESERVATION_SUCCESS:
//   draft.Reservation = true;
//   draft.ReservationSuccessResult = null;
//   draft.ReservationLoading = false;
//   draft.ReservationFormState = null;
//   draft.ReservationConfirmationDetails = action.payload;
//   draft.isFeedbackSubmittedForReservation = action.payload.isFeedbackSubmitted;
//   break;
// case RESERVATION_FAILURE:
//   draft.Reservation = false;
//   draft.ReservationLoading = false;
//   draft.ReservationConfirmationDetails = null;
//   draft.ReservationFail = action.payload.message
//   break;
// case RESERVATION_STORE:
//   draft.ReservationFormState = action.payload;
//   break;